import React from "react";
import Chip from "../Chip";
export const Selection = props => {
  const {
    id,
    children,
    value,
    data,
    onRemove
  } = props;
  const onDelete = event => {
    event.preventDefault();
    event.stopPropagation();
    const val = value || data && data.value;
    onRemove && onRemove(val);
  };
  if (onRemove) {
    return /*#__PURE__*/React.createElement(Chip, {
      id: id,
      tabIndex: -1,
      label: children,
      onDelete: onDelete
    });
  } else {
    return /*#__PURE__*/React.createElement("div", {
      id: id,
      className: "Select-value"
    }, children);
  }
};
export default Selection;